module.exports = __webpack_public_path__ + "static/media/phone_bg_small.c46a114f.png";